import urljoin from 'url-join';
import { portalApi } from './index.api';

const SAMPLESETS_INFO = "samplesetsinfo";

export const sampleSetsInfoApi = portalApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchSampleSetInfo: builder.query({
      query: (projectId, sampleSetId) => ({
        // baseQueryWithAuth handles authorization header automatically
				url: urljoin(SAMPLESETS_INFO, projectId, sampleSetId),
        method: "GET",
      })
    }),
    fetchSampleSetsInfo: builder.query({
      query: (projectId) => ({
        // baseQueryWithAuth handles authorization header automatically
				url: urljoin(SAMPLESETS_INFO, "project", projectId),
        method: "GET",
      })
    }),
    fetchSampleSetsInfoCount: builder.query({
      query: (projectId) => ({
        // baseQueryWithAuth handles authorization header automatically
				url: urljoin(SAMPLESETS_INFO, "project", projectId, "count"),
        method: "GET",
      })
    })
  })
});

export const {
	useFetchSampleSetInfoQuery,
	useFetchSampleSetsInfoQuery,
	useFetchSampleSetsInfoCountQuery } = sampleSetsInfoApi;
/* 
√ GET /api/v1/samplesetsinfo/{projectId}/{sampleSetId}
√ GET /api/v1/samplesetsinfo/project/{projectId}
√ GET /api/v1/samplesetsinfo/project/{projectId}/count
*/